/**
 * Eon API
 * The Eon.io REST API
 *
 * AUTOGENERATED: Do not edit the class manually.
 * Instead edit the .mustache file and run `node --run gen-openapi`
 */

import { EksVolumeRestoreResult } from '../models/EksVolumeRestoreResult';

export class EksNamespaceRestoreResult {
  'volumes': Array<EksVolumeRestoreResult>;

  static readonly discriminator: string | undefined = undefined;

  static readonly attributeTypeMap: Array<{name: string, baseName: string, type: string, format: string}> = [
    {
      "name": "volumes",
      "baseName": "volumes",
      "type": "Array<EksVolumeRestoreResult>",
      "format": ""
    }  ];

  static getAttributeTypeMap() {
    return EksNamespaceRestoreResult.attributeTypeMap;
  }

  public constructor() {
  }
}

